export enum NaceCodesRev2 {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    F = 'F',
    G = 'G',
    H = 'H',
    I = 'I',
    J = 'J',
    K = 'K',
    L = 'L',
    M = 'M',
    N = 'N',
    O = 'O',
    P = 'P',
    Q = 'Q',
    R = 'R',
    S = 'S',
    T = 'T',
    U = 'U'
}

export const NaceCodesRev2Descriptions = new Map([
    ['A', $localize`Agriculture, forestry and fishing`],
    ['B', $localize`Mining and quarrying`],
    ['C', $localize`Manufacturing`],
    ['D', $localize`Electricity, gas, steam and air conditioning supply`],
    ['E', $localize`Water supply; sewerage, waste management and remediation activities`],
    ['F', $localize`Construction`],
    ['G', $localize`Wholesale and retail trade; repair of motor vehicles and motorcycles`],
    ['H', $localize`Transport and storage`],
    ['I', $localize`Accommodation and food service activities`],
    ['J', $localize`Information and communication`],
    ['K', $localize`Financial and insurance activities`],
    ['L', $localize`Real estate activities`],
    ['M', $localize`Professional, scientific and technical activities`],
    ['N', $localize`Administrative and support service activities`],
    ['O', $localize`Public administration and defense`],
    ['P', $localize`Education`],
    ['Q', $localize`Human health and social work activities`],
    ['R', $localize`Arts, entertainment and recreation`],
    ['S', $localize`Other service activities`],
    ['T', $localize`Private households as employers; undifferentiated goods- and services-producing activities of households for own use`],
    ['U', $localize`Activities of extraterritorial organizations and bodies`]
]);
